{
  "version": 1,
  "asset_id": "dea48683-92c6-4ba5-840d-97eba2f9cc80",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/dea48683-92c6-4ba5-840d-97eba2f9cc80/svc-analytics-reporting-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/dea48683-92c6-4ba5-840d-97eba2f9cc80/svc-analytics-reporting-640.avif",
  "original_filename": "svc-analytics-reporting-640.avif",
  "size": 8090,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:42Z"
}
